import React, { useState, useRef } from 'react';

import { uuid } from 'uuidv4';
import QRCode from 'qrcode.react';
import { FaBarcode, FaPlus, FaQrcode } from 'react-icons/fa';
import { AxiosInstance } from 'axios';
import { useModal } from '../../../../../../hooks/Modal';

import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';

import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import Button from '../../Forms/Button';

import { usePrinter } from '../../../../../../hooks/PrinterHook';
import { useConfiguration } from '../../../../../../hooks/Configuration';
import api from '../../../../../../services/api';
import { decodeCracha } from '../Cracha';
import { string } from 'yup';
import { Form } from '@unform/web';
import Input from '../../Forms/Input';
import MaskedInput from '../../Forms/MaskedInput';
import SelectSimple from '../../Forms/SelectSimple';
import TextareaInput from '../../Forms/TextareaInput';

interface IOptions {
  text?: string;
  label?: string;
  value: string | number;
}

interface ICreateModule {
  lineData: Record<string, any>;
  title: string;
  formSchema: Record<string, any>;
  endpoint: string;
  validationSchema: Record<string, IYup>;
  apiRef?: AxiosInstance;
}

export default function CreateParticipant({ configuration }: any): JSX.Element {
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();
  const { addPrint, printIt } = usePrinter();

  const { reloadSearchAll } = useSearch();
  const key = uuid();


  const addParticipant = async (data) => {

    if (!data?.name) {
      addToast({ title: 'Insira um nome', type: 'error' });
      return;
    }

    if (!data?.document_number) {
      addToast({ title: 'Insira um documento de identidade', type: 'error' });
      return;
    }

    if (!data?.email) {
      addToast({ title: 'Insira um e-mail', type: 'error' });
      return;
    }

    data.term = 'Criado no credenciamento';
  
    try {
      await api.post(`/create-user-credentiate/${configuration?.url}`, data)
      reloadSearchAll();
      removeModal('modal')
    }
    catch (err) {

      addToast({ title: err?.response?.data?.message || err?.response?.data?.error || 'Erro ao criar' })
      return;
    }

  }




  const handleQR = async (): Promise<void> => {

    const products = await api.get(`/products-list/${configuration?.url}`);

    const productsList: Array<IOptions> = [];
    products?.data?.rows?.map(i => {
      productsList.push({ label: i?.title, value: i?._id?.toString() })
    })



    const content = <><h2 style={{ color: '#333', fontSize: '14px', margin: '15px auto', textAlign: 'center' }}>Adicionar participante</h2>

      <Form onSubmit={addParticipant} initialData={{ product_id: configuration?.current_event_id_response?.product_id }}>

        <SelectSimple name='product_id' label='Ingresso' options={productsList || []} />


        <Input name='name' placeholder='Nome' />
        <Input name='email' placeholder='E-mail' />
        <MaskedInput
          mask="(99) 999999999"
          name="phone"
          placeholder="Telefone com DDD"
        />
        <MaskedInput
          mask={'999.999.999-99'}
          name="document_number"
          placeholder={'CPF'}
        />
        <Input name='city' placeholder='Cidade' />
        <Input name='state' placeholder='Estado' />

        <Input name='company' placeholder='Empresa' />
        <Input name='position' placeholder='Cargo' />

        <TextareaInput name='extra_5' placeholder='Observações' />

        <aside style={{ display: 'flex', justifyContent: 'center', width: '100%', margin: '10px auto' }}> <button className='greenButton2'>Salvar</button>
        </aside>
      </Form>

    </>;

    if (content) {
      const keyModal = addModal({ title: '', content, key: 'modal' });
    }



  };

  const moduleQRCode = (): JSX.Element => (


    <button className="searchButton" title="Adicionar participante" type="button" onClick={handleQR}>
      <FaPlus />
    </button>
  );

  return moduleQRCode();
}
